var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserDefault = function SvgUserDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M21.577 13.473C26.414 15.496 30.26 20.071 32 25.864c-16.552 6.28-32 0-32 0 1.714-5.706 5.469-10.232 10.202-12.3a6.543 6.543 0 0 0 11.375-.09M16 0a6.551 6.551 0 1 1 0 13.102A6.551 6.551 0 0 1 16 0",
    transform: "translate(0 1.672)"
  })));
};
export { SvgUserDefault as ReactComponent };
export default __webpack_public_path__ + "assets/user-default.262a842da6bdbceae62c6cffb7ad868a.svg";